export enum  AgmType {
    booking = 'booking',
    fleet = 'fleet',
    track ='track',
    fleetmultiple= 'fleetmultiple',
    bookingDetail ='bookingDetail',
    snits='snits',
    snitsfleetmultiple= 'snitsfleetmultiple',
   }
